//@flow
import type {
  DirSvcMapping,
  DirSvcMappingEntry,
  DirSvcNode,
} from 'state/types';

export const ALL_CATALOGS_GUID = '9ED0794C-5DA9-4dd4-8D9C-7BF6D954E8B0';
export const NO_CATALOGS_GUID = '8B63F84B-5139-4a33-841B-5CAA6052743E';

export const QUERY_TYPE_SECURITY_GROUPS = 'QUERY_TYPE_SECURITY_GROUPS';
export const QUERY_TYPE_DISTRIBUTION_GROUPS = 'QUERY_TYPE_DISTRIBUTION_GROUPS';
export const QUERY_TYPE_USERS = 'QUERY_TYPE_USERS';
export const QUERY_TYPE_ENTIRE_TREE = 'QUERY_TYPE_ENTIRE_TREE';
export const QUERY_TYPE_NAME = 'QUERY_TYPE_NAME';

export const AD_MAPPING_QUERIES = {
  QUERY_TYPE_SECURITY_GROUPS: {
    name: 'SECURITY_GROUPS',
    query: '(&(objectClass=group)(groupType<=-2147483640))',
  },
  QUERY_TYPE_DISTRIBUTION_GROUPS: {
    name: 'DISTRIBUTION_GROUPS',
    query: '(&(objectClass=group)(groupType>=0))',
  },
  QUERY_TYPE_USERS: {
    name: 'USERS',
    query:
      '(&(&(objectClass=person)(sAMAccountName=*))(!(objectClass=computer)))',
  },
  QUERY_TYPE_ENTIRE_TREE: {
    name: 'ENTIRE_TREE_UNDER_SEARCH_BASE',
    query: '(objectClass=*)',
  },
  QUERY_TYPE_NAME: {
    name: 'NAME',
    query: 'name=',
  },
};

export const NAME_QUERY_OP = {
  EQUALS: 'EQUALS',
  CONTAINS: 'CONTAINS',
  STARTS_WITH: 'STARTS_WITH',
};

export function getMappingEntriesForDestination(
  dsMappings: DirSvcMapping[],
  destination: string
): DirSvcMappingEntry[] {
  const found = dsMappings.find(m => m.targetGroupGuid === destination);
  return (found && found.entries) || [];
}

// Some user names, such as many of those on extnsis.com, have an escaped comma
// this method removes the backslash escape character from the name
export function getUserName(dnName: string) {
  let formattedName = '';
  const token = '\r\n';

  // first, replace any escaped commas with a token (to handle
  // cases such as the extnsis.com domain where some users have
  // escaped commas in their user name)
  formattedName = dnName.replace('\\,', token);

  // next extract the name by splitting the line on the equals sign and comma
  formattedName = formattedName.split('=')[1];
  formattedName = formattedName.split(',')[0];

  // and finally, replace the escaped comma (if it ever existed) with an unescaped comma
  formattedName = formattedName.replace(token, ',');

  return formattedName;
}

export function getNodeType(node: DirSvcNode) {
  return node && node.attributes && node.attributes.objectClass;
}

// TODO - look at the logic in IdentityServiceModel.as in old admin.
export function isNodeUser(node: DirSvcNode) {
  return getNodeType(node) === 'user';
}

export function isNodeGroup(node: DirSvcNode) {
  return getNodeType(node) === 'group';
}

export function ldapSourceToNumber(sourceType: ?string) {
  // TODO - other sourceTypes.
  switch (sourceType) {
    case 'user':
      return 3;
    case 'group':
      return 2;
    default:
      return 0;
  }
}
export const SOURCE_TYPE_USER_EXCLUSION = 4;



// WEBPACK FOOTER //
// ./src/util/dirSvcUtils.js